import { Loader2 } from "lucide-react";
import { TableCell, TableRow } from "./table";

interface TableLoadProps {
    colSpan: number;
}

export function TableLoad({ colSpan }: TableLoadProps) {
    return (
        <TableRow>
            <TableCell colSpan={colSpan}>
                <div className="flex items-center justify-center py-24">
                    <Loader2 className="h-8 w-8 animate-spin text-[#F4C83E]" />
                </div>
            </TableCell>
        </TableRow>
    );
}
